/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { Avatar, Box, CardContent, List, ListItem, ListItemText, Stack } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { stringAvatar } from '../../../utils/helpers/string-to-color';
import { Typography } from '@mui/material';
import deleteCookie from '../../../utils/helpers/delete-cookie';
import { COOKIE_KEYS, DEALER_STATUS, DEALER_STATUS_LABEL, HELPLINE_NUMBER, TOAST_OPTIONS, WEB_VIEW_EVENTS } from '../../../constants/app-constants';
import { useNavigate } from 'react-router-dom';
import { ROUTE_PATH } from '../../../constants/route-constants';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import CallIcon from '@mui/icons-material/Call';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import HelpSharpIcon from '@mui/icons-material/HelpSharp';
import { IconButton } from '@mui/material';
import KeyboardArrowRightSharpIcon from '@mui/icons-material/KeyboardArrowRightSharp';
import { useDispatch } from 'react-redux';
import { setSearchFlag } from '../../../store/auctions/action';
import { logoutUser } from '../../../store/login/action';
import { sendWebviewEvent } from '../../../utils/helpers/webview-event';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import BasicModal from '../../common/modal/index';
import { Card } from '@mui/material';
import { CardActions } from '@mui/material';
import { Chip, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import PageLoader from '../../common/page-loader';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { clearItem } from '../../../utils/helpers/storage-crud';

const MyAccount = ({ user, setupToastConnect, resetUserConnect, userDeactivationConnect, fetchDealerConnect, setUserConnect }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [showConfirmPopup, setShowConfirmPopup] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const { contactPerson, status, rmPhone, dealerCode } = user || {};
    const handleLogout = () => {
        deleteCookie(COOKIE_KEYS.ACCESS_TOKEN);
        clearItem(COOKIE_KEYS.CALLBACK_REQUESTES);
        dispatch(setSearchFlag(false));
        resetUserConnect();
        dispatch(logoutUser());
        navigate(ROUTE_PATH.LOGIN);
    };

    useEffect(() => {
        if (dealerCode) {
            setIsLoading(true);
            fetchDealerConnect(dealerCode).then(dealer => {
                if (dealer?.status !== DEALER_STATUS.BANNED) {
                    setUserConnect({ ...dealer });
                } else {
                    handleLogout();
                }
            }).finally(() => setIsLoading(false));
        }
    }, []);

    const handleManageProfile = () => {
        setupToastConnect({ message: 'Manage profile will be ready shortly!', type: TOAST_OPTIONS.INFO, horizontal: 'right' });
    };

    const handleDeleteProfile = () => {
        setShowConfirmPopup(true);
    };

    const onDeleteConfirmation = () => {
        setShowConfirmPopup(false);
        setIsLoading(true);
        userDeactivationConnect({ isDeactivationRequested: true }).then(() => {
            setupToastConnect({ message: 'Profile deletion request submitted successfully!', type: TOAST_OPTIONS.SUCCESS, horizontal: 'bottom' });
        }).finally(() => {
            setIsLoading(false);
        });
    };
    const handleCustomerSupport = (phoneNumber) => {
        sendWebviewEvent({ data: phoneNumber, type: WEB_VIEW_EVENTS.CALL });
        if (phoneNumber) window.location.href = `tel:${phoneNumber}`;
    };

    const handleNavigation = (path) => {
        navigate(path);
    };

    const manageAccountItems = [
        { icon: AccountCircleIcon, title: 'Manage Profile', click: handleManageProfile },
        { icon: PersonRemoveIcon, title: 'Delete Account', click: handleDeleteProfile },
        { icon: HelpSharpIcon, title: 'Help & Support', click: () => { }, type: 'expand' },
        { icon: LogoutIcon, title: 'Logout', click: handleLogout }
    ];

    return (
        <Box className="w-full flex flex-col justify-between">
            <Stack className='shadow -mx-5 -mt-6 p-6 pb-16 bg-background relative' >
                <Stack direction={'row'} spacing={3} className='flex items-center'>
                    <Avatar {...stringAvatar(contactPerson?.name || 'Cars24 Partner')} />
                    <Stack>
                        <Typography variant="h6">
                            {contactPerson?.name || 'Cars24 Partner'}
                        </Typography>
                        <Typography variant="h6">
                            {contactPerson?.primaryMobileNumber}
                        </Typography>
                    </Stack>
                </Stack>
                <Chip className='absolute bottom-0 text-base rounded-none w-full left-0' label={DEALER_STATUS_LABEL[status] || status} />
            </Stack>
            <Stack direction={'row'} justifyContent='space-between' gap={3} className='mt-6 mb-2'>
                <Button onClick={handleCustomerSupport.bind(this, HELPLINE_NUMBER)} variant="contained" className='capitalize w-full justify-between font-bold' disableElevation color='bg' size='small' endIcon={<CallIcon className='text-secondary' />}>
                    <span className='text-text no-underline'>Customer Support (11am-7pm)</span>
                </Button>
                <Button onClick={handleCustomerSupport.bind(this, rmPhone)} variant="contained" className='capitalize w-full justify-between font-bold' disableElevation color='bg' size='small' endIcon={<CallIcon className='text-secondary' />}>
                    <span className={`text-text no-underline ${!rmPhone && 'pointer-events-none'}`}>Sales Representative</span>
                </Button>
            </Stack>
            <List>
                {manageAccountItems?.map(({ icon: IconComponent, click, title, type }, idx) => (
                    <React.Fragment key={idx}>
                        <ListItem key={idx} disablePadding onClick={click} divider className='flex justify-between items-center flex-row my-4 pb-3' secondaryAction={
                            type !== 'expand' && <IconButton edge="end" aria-label="Arrow" className='-mt-3 -mr-7'>
                                <KeyboardArrowRightSharpIcon />
                            </IconButton>
                        }>
                            <React.Fragment key={idx}>
                                {type !== 'expand' ? <React.Fragment key={idx}> <IconComponent className='pr-3' />
                                    <ListItemText primary={title} /></React.Fragment> : <Accordion className='shadow-none p-0 my-1 w-full'>
                                    <AccordionSummary className='p-0 m-0 pr-1 min-h-max' classes={{ expanded: 'min-h-0', content: 'm-0' }} expandIcon={<KeyboardArrowDownIcon />}>
                                        <IconComponent className='pr-3' />
                                        <Typography>{title}</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails className='pt-6 pb-1 flex justify-between gap-4'>
                                        <Button variant="contained" onClick={handleNavigation.bind(null, ROUTE_PATH.TERMS_AND_CONDITIONS)} disableElevation className='capital w-full font-bold' color='primary' size='small'>
                                            Terms & Conditions
                                        </Button>
                                        <Button variant="contained" onClick={handleNavigation.bind(null, ROUTE_PATH.FAQ)} className='capital w-full font-bold' disableElevation color='primary' size='small'>
                                            FAQ's
                                        </Button>
                                    </AccordionDetails>
                                </Accordion>
                                }
                            </React.Fragment>
                        </ListItem>
                    </React.Fragment>
                ))}
            </List>
            <BasicModal open={showConfirmPopup} handleClose={setShowConfirmPopup.bind(null, false)}>
                <Card className='m-6'>
                    <CardContent>
                        <Typography variant='body1'>
                            Are you sure to delete your account ?
                        </Typography>
                    </CardContent>
                    <CardActions className='flex justify-end m-1'>
                        <Button size="small" variant='contained' onClick={setShowConfirmPopup.bind(null, false)}>Cancel</Button>
                        <Button size="small" variant='outlined' onClick={onDeleteConfirmation}>Delete</Button>
                    </CardActions>
                </Card>
            </BasicModal>
            {isLoading && <PageLoader />}
        </Box>
    );
};

MyAccount.propTypes = {
    user: PropTypes.object,
    setupToastConnect: PropTypes.func,
    resetUserConnect: PropTypes.func,
    userDeactivationConnect: PropTypes.func,
    fetchDealerConnect: PropTypes.func,
    setUserConnect: PropTypes.func
};

export default MyAccount;
